import type { ReactNode } from "react";
import styles from "./CmsEmptyState.module.css";

type CmsEmptyStateProps = {
  message: string;
  icon?: ReactNode;
  loading?: boolean;
  action?: {
    label: string;
    onClick?: () => void;
    href?: string;
  };
};

export function CmsEmptyState({ message, icon, loading, action }: CmsEmptyStateProps) {
  return (
    <div className={styles.container}>
      {loading ? (
        <svg
          className={styles.spinner}
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          aria-label={message}
        >
          <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="2" opacity="0.15" />
          <path
            d="M12 2a10 10 0 0 1 10 10"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
          />
        </svg>
      ) : (
        <>
          {icon && <div className={styles.icon}>{icon}</div>}
          <p className={styles.message}>{message}</p>
          {action &&
            (action.href ? (
              <a href={action.href} className={styles.action}>
                {action.label}
              </a>
            ) : (
              <button type="button" className={styles.action} onClick={action.onClick}>
                {action.label}
              </button>
            ))}
        </>
      )}
    </div>
  );
}
